import React, { useContext, useState, useRef, useEffect } from 'react';
import Sidebar from '../Sidebar';
import { addcontext } from '../../ContextShare/ContextShare';
import klaimage from '../../Assets/kla-logo.png';
import MemberListLessDetails from '../Member/MemberListLessDetails';
import FilterTable from '../FilterTable';
import { Icon } from '@iconify/react/dist/iconify.js'
import { ToastContainer } from 'react-toastify';

function MembersR() {
    const { addMember, setaddMember } = useContext(addcontext);
    const {isSidebarCloses,setIsSidebarCloses}=useContext(addcontext)
 
    const [isFilterClicked, setIsFilterClicked] = useState(false);
    const [filterPosition, setFilterPosition] = useState({ top: 0, left: 0 });
    const filterButtonRef = useRef(null);
    const filterRef = useRef(null);

    const handleMemberAdd = () => {
        setaddMember(!addMember);
    };

    const toggleFilter = () => {
        setIsFilterClicked(!isFilterClicked);
    };

    useEffect(() => {
        if (filterButtonRef.current) {
            const rect = filterButtonRef.current.getBoundingClientRect();
            setFilterPosition({ top: rect.bottom, left: rect.left });
        }
    }, [isFilterClicked]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (filterRef.current && !filterRef.current.contains(event.target) && !filterButtonRef.current.contains(event.target)) {
                setIsFilterClicked(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (<>
        <div className='flex w-full h-full' style={{ fontFamily: 'ropa sans' }}>
            <div className='flex flex-col w-full h-full'>
                <div className='w-full h-24 flex flex-row justify-between bg-success rounded border' style={{height:'13vh'}}>
                    <div className='w-2/12 flex items-center'>
                        <img src={klaimage} className='w-6/12 ms-12 lg:flex hidden p-1' alt="KLA Logo" />
                    </div>

                    <div className='flex items-center' onClick={()=>setIsSidebarCloses(!isSidebarCloses)}>
                    <Icon icon="teenyicons:expand-solid" className='text-2xl font-bold  cursor-pointer'/>
                    </div>

                    <div className='w-10/12 flex flex-row justify-end gap-5 pr-5'>
                       
                       {!addMember&& <div className='flex md:w-52 w-4/12 items-center h-full'>
                            <button
                                ref={filterButtonRef}
                                onClick={toggleFilter}
                                className='p-1 flex w-full h-2/5 justify-center items-center rounded-full hover:bg-blue-600 hover:text-white border border-blue-600 transition transform duration-500 ease-in-out'
                            >
                                <i className="fa-solid fa-filter md:me-3 me-1 lg:flex hidden"></i>
                                <span>Filters</span>
                            </button>
                        </div>}

                        <div className='flex md:w-52 w-4/12 items-center h-full'>
                            <button
                                onClick={handleMemberAdd}
                                className='flex w-full h-2/5 justify-center items-center rounded-full cursor-pointer text-white bg-blue-600 border hover:bg-blue-700 transform duration-500 ease-in-out'
                                
                            >
                                <i className={`fa-solid ${addMember ? 'fa-xmark' : 'fa-plus'} md:me-2 me-1`}></i>
                                <span className='lg:text-sm text-xs'>{addMember ? 'Close' : 'Add new member'}</span>
                            </button>
                        </div>
                    </div>
                </div>

                <div className='flex flex-row'>
                <div className={`${isSidebarCloses&&'hidden'} md:w-4/12 lg:w-3/12 xl:w-2/12`}>
                        <Sidebar />
                        </div>
                        <div className={`${isSidebarCloses?'w-full':'lg:w-9/12 xl:w-10/12 w-full'} overflow-y-scroll pt-2`} style={{ height: '87vh' }}>
                        <MemberListLessDetails />
                    </div>
                </div>
            </div>

            {isFilterClicked && (
                <div
                    ref={filterRef}
                    className='w-8/12 md:w-2/12 flex items-center z-50 absolute transition-opacity duration-500 opacity-100 '
                    style={{ top: filterPosition.top, left: filterPosition.left-18 }}
                >
                    <FilterTable setIsFilterClicked={setIsFilterClicked}/>
                </div>
            )}
        </div>
        <ToastContainer
        position="top-center"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        draggable
        pauseOnHover
        theme="light"
      />
        </>
    );
}

export default MembersR;
